import LayoutMain from "./layout/LayoutMain";
import LayoutHeader from "./layout/LayoutHeader";
import InfiniteScroll from "./InfiniteScroll";
import IndexGoods from './IndexGoods'
import GoodsInfo from './GoodsInfo'
import GoodsBox from './GoodsBox'
import GoodsBox2 from './GoodsBox2'
import SeamlessScroll from './SeamlessScroll'
import List from './List'
import SellComponent from './SellComponent'
import GoodsItem from './GoodsItem'
import BillItem from './BillItem'
import Goods from './Goods'
import SellgoodsItem from './SellgoodsItem'
import NoticeScroll from './NoticeScroll'
import HomeScroll from './HomeScroll'
import RankScroll from './RankScroll'
import CollectScroll from './CollectScroll'
import OrderScroll from './OrderScroll'
import HomeScroll2 from './HomeScroll2'
import BillItem2 from './BillItem2'
import MarginRecharge from './MarginRecharge'
import RecScroll from './RecScroll'
import MsgScroll from './MsgScroll'
import MarketScroll from './MarketScroll'
import AppEnv from './AppEnv'
import HomeDj from './HomeDj'
const components = [
  LayoutMain,
  LayoutHeader,
  InfiniteScroll,
  IndexGoods,
  GoodsInfo,
  GoodsBox,
  GoodsBox2,
  SeamlessScroll,
  List,
  SellComponent,
  GoodsItem,
  BillItem,
  Goods,
  SellgoodsItem,
  NoticeScroll,
  HomeScroll,
  RankScroll,
  CollectScroll,
  OrderScroll,
  HomeScroll2,
  BillItem2,
  MarginRecharge,
  RecScroll,
  MsgScroll,
  MarketScroll,
  AppEnv,
  HomeDj
];
const install = (Vue, opts = {}) => {
  if (install.installed) return;
  for (let cop of components) {
    if (!cop.name) continue;
    Vue.component(cop.name, cop);
  }
};
if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}
export default install;
